<template>
  <div
    class="transaction-review-status-log d-flex flex-column"
    :class="{'transaction-review-status-log--detail': place === 'detail'}"
  >
    <transaction-current-status
      :showTimeline.sync="showTimeline"
      @toggleTimeline="emitToggleTimeLine"
      :hasReviewSteps="hasReviewSteps"
      :place="place"
    />

    <div
      class="timeline-container"
      v-if="showTimeline"
    >
      <template v-for="(reviewLog, index) in transactionReviewLogList">
        <div
          v-if="reviewLog.targetStatus"
          :key="reviewLog.id"
          :class="{
        'status--row-reason': ((reviewLog.targetStatus && reviewLog.targetStatus.code === REVIEW_STATUS.CANCELLED) || reviewLog.notes),
        'status--row-black': !reviewLog.created_by_user,
        'status--row--last-node' : reviewLog.id === transactionReviewLog[transactionReviewLog.length -1].id,
        'status--row-first-node-larger' : index=== 0 && transactionReviewLogList[index+1] && transactionReviewLogList[index+1].notes,
        'status--row-first-node-fixed' : _setFirstNodeFixed(index)
        }"
          class="status--row"
        >
          <div
            :class="{'status-line-reason': index > 0 && (transactionReviewLogList[index - 1].targetStatus && transactionReviewLogList[index - 1].targetStatus.code === REVIEW_STATUS.CANCELLED || transactionReviewLogList[index -1].notes)}"
            class="status-line"
          ></div>
          <div
            v-tooltip="tooltipInfo(reviewLog)"
            class="status-block ml-3"
          >
            <span
              class="status-log-label"
              :class="{'status-log-label-user': reviewLog.created_by_user}"
            >{{renderCurrentStatusLine(reviewLog)}}</span>
            <small v-if="reviewLog.targetStatus && reviewLog.targetStatus.code === REVIEW_STATUS.CANCELLED">{{renderReason(reviewLog.rejectedReason)}}</small>
            <template v-if="reviewLog.notes">
              <v-clamp
                tag="small"
                :max-height="'45px'"
                :max-lines="3"
                v-tooltip="reviewLog.notes"
              >"{{renderReason(reviewLog.notes)}}"</v-clamp>
            </template>
          </div>
        </div>
      </template>
    </div>
    <div
      v-if="showTransactionCreated && !showTimeline"
      class="transaction-created"
    >
      <div
        class="status--row status--row-black"
        v-for="(reviewLog, index) in transactionReviewLogWithComments"
        :key="reviewLog.id"
      >

        <div class="status-line-container status-line-container--collapsed">
          <div class="status-line--coment"></div>
          <img
            class="stauts-line--striped"
            alt="icon-log-collapsed"
            :src="require('@/assets/img/icons/icon-dotted-border.png')"
          />
          <div
            class="status-line--bottom"
            :class="{'status-line--bottom--after' : index > 0}"
          ></div>
        </div>
        <div
          v-tooltip="tooltipInfo(reviewLog)"
          class="status-block ml-3"
        >
          <span
            class="status-log-label"
            :class="{'status-log-label-user': reviewLog.created_by_user}"
          >{{renderCurrentStatusLine(reviewLog)}}</span>
          <small
            class="collapsed ellipsis"
            v-tooltip="reviewLog.notes"
            v-if="reviewLog.notes"
          >"{{renderReason(reviewLog.notes)}}"</small>
        </div>

      </div>
      <div class="status--row">
        <div
          class="status-line"
          v-if="(transactionReviewLogWithComments[transactionReviewLogWithComments.length - 1] && !transactionReviewLogWithComments[transactionReviewLogWithComments.length - 1].notes) || transactionReviewLogWithComments.length === 0"
        ></div>
        <div
          class="status-line-container status-line-container--collapsed"
          v-else
        >
          <div class="status-line--coment"></div>
          <img
            class="stauts-line--striped"
            alt="icon-log-collapsed"
            :src="require('@/assets/img/icons/icon-dotted-border.png')"
          />
          <div class="status-line--bottom"></div>
        </div>
        <div class="status-block ml-3">
          <span class="status-log-label status-log-label-user">{{ $t('transactions_review_status__CREATED') }} - {{ transaction.date | formatTheDate('short') }}</span>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import TransactionCurrentStatus from './TransactionCurrentStatus.vue'
import { REVIEW_STATUS, REVIEW_STATUS_LOG_CREATED, REVIEW_STATUS_LOG_SEND_TO_REVIEW, REVIEW_STATUS_LOG_UNDER_REVIEW } from '@/constants/reviewStatus'
import VClamp from 'vue-clamp'
export default {
  name: 'TransactionReviewStatusLog',
  data () {
    return {
      showTimeline: false,
      reviewLog: []
    }
  },
  components: {
    TransactionCurrentStatus,
    VClamp
  },
  props: {
    transaction: {
      type: Object,
      required: true
    },
    place: {
      type: String,
      default: ''
    },
    showTimeLine: {
      type: Boolean

    }
  },
  computed: {
    REVIEW_STATUS () {
      return REVIEW_STATUS
    },
    transactionReviewLog () {
      return this.transaction?.transactionReviewStatusLogs
    },
    transactionReviewLogList () {
      if (this.showTimeline) {
        return this.reviewLog.filter(el => el.targetStatus?.code !== REVIEW_STATUS.DRAFT)
      } else {
        return this.transactionContractedReviewLogList.filter(el => el.targetStatus?.code !== REVIEW_STATUS.DRAFT)
      }
    },
    transactionReviewLogWithComments () {
      return this.reviewLog.filter(el => el.notes)
    },
    hasReviewSteps () {
      return this.transactionReviewLog?.length > 0
    },
    lastReviewLogItem () {
      return this.transactionReviewLogList[this.transactionReviewLogList.length - 1]
    },
    firstReviewLogItem () {
      return this.transactionReviewLogList[0]
    },
    showTransactionCreated () {
      return this.place === 'detail'
    }
  },
  methods: {
    emitToggleTimeLine (event) {
      this.$emit('toggleTimeline', event)
    },
    tooltipInfo (reviewLog) {
      if (reviewLog.created_by_user) return undefined
      return `${this.formatDate(reviewLog.createdAt)} - ${reviewLog.reviewedBy?.firstName} ${reviewLog.reviewedBy?.lastName}`
    },
    isLastItem (reviewLog) {
      return this.lastReviewLogItem.id === reviewLog.id
    },
    isFirstItem (reviewLog) {
      return this.firstReviewLogItem.id === reviewLog.id
    },
    formatDate (date) {
      if (this.$moment.utc(date).isValid()) {
        return this.$moment.utc(date).format('DD/MM/YY')
      }
      return ''
    },

    _initializeReviewLog () {
      let createdStatusNode = []
      if (this.transactionReviewLog?.length > 0) {
        createdStatusNode = [{
          id: 'fake_id__2',
          targetStatus: {
            code: REVIEW_STATUS_LOG_CREATED,
            name: REVIEW_STATUS_LOG_CREATED
          },
          originStatus: {
            code: REVIEW_STATUS_LOG_CREATED,
            name: REVIEW_STATUS_LOG_CREATED
          },
          notes: '',
          created_by_user: true
        }]
        if (this.transaction.reviewStatus.code !== 'DRAFT') {
          createdStatusNode.unshift({
            id: 'fake_id__1',
            targetStatus: {
              code: REVIEW_STATUS_LOG_SEND_TO_REVIEW,
              name: REVIEW_STATUS_LOG_SEND_TO_REVIEW
            },
            originStatus: {
              code: REVIEW_STATUS_LOG_SEND_TO_REVIEW,
              name: REVIEW_STATUS_LOG_SEND_TO_REVIEW
            },
            notes: '',
            created_by_user: true
          })
        }
      }
      this.reviewLog = []
      if (this.transactionReviewLog) {
        this.transactionReviewLog.forEach((element) => {
          let sentForReview
          if (element.originStatus?.code === REVIEW_STATUS.CANCELLED) {
            sentForReview = {
              id: `fake_id__${Math.random() + new Date().getTime()}`,
              targetStatus: {
                code: element.targetReviewFlowStep === null ? REVIEW_STATUS_LOG_UNDER_REVIEW : REVIEW_STATUS_LOG_SEND_TO_REVIEW,
                name: element.targetReviewFlowStep === null ? REVIEW_STATUS_LOG_UNDER_REVIEW : REVIEW_STATUS_LOG_SEND_TO_REVIEW
              },
              originStatus: {
                code: element.targetReviewFlowStep === null ? REVIEW_STATUS_LOG_UNDER_REVIEW : REVIEW_STATUS_LOG_SEND_TO_REVIEW,
                name: element.targetReviewFlowStep === null ? REVIEW_STATUS_LOG_UNDER_REVIEW : REVIEW_STATUS_LOG_SEND_TO_REVIEW
              },
              notes: '',
              created_by_user: true
            }
          }
          if (element.targetReviewFlowStep !== null || (element.targetReviewFlowStep === null && element.nextReviewFlowStep !== null) || (element.targetReviewFlowStep === null && element.targetStatus?.code !== REVIEW_STATUS.AWAITING_REVIEW)) {
            this.reviewLog.push(element)
          }
          if (sentForReview) {
            this.reviewLog.push(sentForReview)
          }
        })
      }
      this.reviewLog.push(...createdStatusNode)
    },
    renderReason (reason = '') {
      return reason
    },
    renderCurrentStatusLine (reviewStatusLog) {
      if (!reviewStatusLog) return ''

      if (reviewStatusLog.originStatus === null) {
        return this._generateCurrentStatusLineForOrigin(reviewStatusLog)
      } else {
        return this._generateCurrentStatusLineForTarget(reviewStatusLog)
      }
    },
    _generateCurrentStatusLineForOrigin (reviewStatusLog) {
      const { targetStatus, nextReviewFlowStep } = reviewStatusLog
      if (targetStatus?.code === REVIEW_STATUS_LOG_CREATED) {
        return this.$t('transactions_review_status__CREATED')
      }
      if (targetStatus?.code === REVIEW_STATUS.AWAITING_REVIEW) {
        return this.$t('transactions_review_status_send_for_review')
      }
      if (nextReviewFlowStep) {
        return this.$t('transactions_review_status__VALID') + ': ' + nextReviewFlowStep.name
      }
      if (targetStatus?.code === REVIEW_STATUS.APPROVED) {
        return this.$t('transactions_review_status__VALID')
      }
      return this.$t(`transactions_review_status__${targetStatus?.code}`)
    },
    _generateCurrentStatusLineForTarget (reviewStatusLog) {
      const { targetStatus, isPersonalExpense, nextReviewFlowStep, originStatus, targetReviewFlowStep } = reviewStatusLog
      if (originStatus.code === REVIEW_STATUS_LOG_CREATED) {
        return this.$t('transactions_review_status__CREATED')
      }
      if (isPersonalExpense) {
        return this.$t('transactions_funnel_actions_mark_as_personal')
      }
      if (targetStatus?.code === REVIEW_STATUS_LOG_SEND_TO_REVIEW) {
        return this.$t('transactions_review_status_log_sent_for_review')
      }

      if (targetStatus?.code === REVIEW_STATUS_LOG_UNDER_REVIEW) {
        return this.$t('transactions_review_status__OFFICE_FLOW_REVISION')
      }

      if (targetStatus?.code === REVIEW_STATUS.CANCELLED) {
        if (targetReviewFlowStep) {
          return `${this.$t('transactions_review_status__NOT_VALID')}: ${targetReviewFlowStep?.name}`
        }
        return this.$t('transactions_review_status__NOT_VALID')
      }

      if (targetStatus?.code === REVIEW_STATUS.APPROVED) {
        if (targetReviewFlowStep) {
          return `${this.$t('transactions_review_status__VALID')}: ${targetReviewFlowStep?.name}`
        }
        return this.$t('transactions_review_status__VALID')
      }
      // Está dentro del flujo custom

      if (targetStatus?.code === REVIEW_STATUS.OFFICE_FLOW_REVISION) {
        return `${this.$t('transactions_review_status__VALID')}: ${targetReviewFlowStep?.name}`
      }
      // Está en awaiting pero va a pasar a flujo custom
      if (targetStatus?.code === REVIEW_STATUS.AWAITING_REVIEW) {
        if (nextReviewFlowStep) {
          return `${this.$t('transactions_review_status_send_for_review')}: ${nextReviewFlowStep?.name}`
        }
        return ''
      }
      return ''
    },
    _nodeBetweenCommentsClass (index) {
      const previousNodeHasAnyReject = !!(this.transactionReviewLogList[index - 1]?.rejectedReason)
      const nextNodeHasAnyComment = !!(this.transactionReviewLogList[index + 1]?.notes)
      return previousNodeHasAnyReject && nextNodeHasAnyComment
    },
    _setFirstNodeFixed (index) {
      const nextNodeHasAnyComment = !this.transactionReviewLog[index + 1]?.notes

      return nextNodeHasAnyComment && index === 0
    }
  },
  watch: {
    'transaction.id': function (newV, oldV) {
      if (newV !== oldV) {
        this._initializeReviewLog()
      }
    },
    'transaction.reviewStatus': function (newV, oldV) {
      this._initializeReviewLog()
    },
    showTimeLine: function (newV) {
      if (newV) {
        this.showTimeline = true
      } else {
        this.showTimeline = false
      }
    }
  },
  created () {
    this._initializeReviewLog()
  }

}
</script>
<style scoped lang="scss" src="../../../_styles/transaction-review-status-log-styles.scss"></style>
